angular.module('elfium').filter('reportPhaseLabel', ['REPORT_PHASE', 'REPORT_PHASE_LABEL', function (REPORT_PHASE, REPORT_PHASE_LABEL) {
    var that = this;
    return function (phase) {
        switch (phase) {
            case REPORT_PHASE.PROBEHLA_PRVNI_SCHUZKA:
                return REPORT_PHASE_LABEL.PROBEHLA_PRVNI_SCHUZKA;
            default:
                return phase;
        }
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/report/reportPhaseLabelFilter.ts